var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitoring(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M27.500,7.500 L27.500,2.500 L22.500,2.500 L22.500,-0.000 L30.000,-0.000 L30.000,7.500 L27.500,7.500 ZM20.399,18.632 L27.500,25.734 L25.730,27.500 L18.632,20.400 C16.938,21.716 14.811,22.500 12.500,22.500 C6.977,22.500 2.500,18.023 2.500,12.500 C2.500,6.977 6.977,2.500 12.500,2.500 C18.023,2.500 22.500,6.977 22.500,12.500 C22.500,14.811 21.716,16.939 20.399,18.632 ZM12.500,5.000 C8.364,5.000 5.000,8.364 5.000,12.500 C5.000,16.636 8.364,20.000 12.500,20.000 C16.635,20.000 20.000,16.636 20.000,12.500 C20.000,8.364 16.635,5.000 12.500,5.000 ZM10.000,12.500 L7.500,12.500 C7.500,9.742 9.742,7.500 12.500,7.500 L12.500,10.000 C11.120,10.000 10.000,11.120 10.000,12.500 ZM2.500,27.500 L7.500,27.500 L7.500,30.000 L-0.000,30.000 L-0.000,22.500 L2.500,22.500 L2.500,27.500 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoring);
export default __webpack_public_path__ + "static/media/monitoring.d8885980.svg";
export { ForwardRef as ReactComponent };